import React from 'react';
import { Tooltip } from '@mui/material';
import './Tooltip.module.scss';

const MLTooltip = ({
  children,
  tooltipTitle = '',
  tooltipPlacement = 'bottom',
  fontSize = 16,
}) => {
  if (!tooltipTitle || tooltipTitle === '') {
    return children;
  }
  return (
    <Tooltip
      title={
        <span
          className="whitespace-pre-line break-words"
          style={{
            fontSize: `${fontSize}px`,
            lineHeight: `${fontSize + 4}px`,
            fontWeight: 400,
          }}
        >
          {tooltipTitle}
        </span>
      }
      placement={tooltipPlacement}
      arrow
    >
      {children}
    </Tooltip>
  );
};

export default MLTooltip;
